import useApi from "../../hooks/useApi";
import "./user-entry.component.scss";
import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

const FetchUpdateUserEntry = ({ show, onClose }) => {
  const [email, setEmail] = useState("");
  const { get } = useApi();
  const [error, setError] = useState("");
  const fetchUser = async () => {
    setError("");
    const url = `users/email/${email.trim()}`;

    try {
      const response: any = await get(url);
      if (response && response.status === 200) {
        // Assuming response.data contains the user data
        const userData = response.data;
        if (userData && userData.email) {
          // Handle the user data as needed
          console.log("User data fetched successfully:", userData);
          // You can also close the modal or perform other actions here
          onClose(userData); // Pass the user data back to the parent component
        } else {
          setError("User not found or invalid email");
        }
      } else {
        setError("User not found or invalid email");

        console.log("User not found or invalid email");
      }
    } catch (error) {
      console.log("error==>", error);
      setError("Error occurred while fetching User");
    }
  };

  const renderPopup = () => {
    return (
      <Modal
        show={show}
        onHide={onClose}
        backdrop="static"
        keyboard={false}
        className="user-entry"
      >
        <Modal.Header closeButton>
          <Modal.Title>Enter a user email to search</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <input
            type="text"
            className="form-control emailFetch"
            placeholder="Enter User Email"
            onChange={(e) => setEmail(e.target.value)}
          />
          <div className="container mt-3">
            <div className="d-flex justify-content-center mt-3">
              <Button
                onClick={fetchUser}
                className="btnFetch"
                disabled={!email}
              >
                Fetch User
              </Button>
            </div>
            <div className="d-flex justify-content-center mt-3">
              <p className="error">{error}</p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  return renderPopup();
};

export default FetchUpdateUserEntry;
